// src/modules/competitions/components/JudgeImageTypeCard.tsx

import React, { useState } from 'react';
import Button from '../../../shared/components/ui/Button';
import { JudgeImageType } from '../types/judge';

interface JudgeImageTypeCardProps {
  imageType: JudgeImageType;
  onEvaluate: (imageTypeId: number) => void;
}

const JudgeImageTypeCard: React.FC<JudgeImageTypeCardProps> = ({
  imageType,
  onEvaluate
}) => {
  const [showOverlay, setShowOverlay] = useState(false);
  const isMobile = window.innerWidth <= 768;

  const progress = imageType.total_submissions > 0
    ? (imageType.evaluated_submissions / imageType.total_submissions) * 100
    : 0;

  const handleClick = () => {
    if (isMobile) {
      setShowOverlay(!showOverlay);
    }
  };

  const handleMouseEnter = () => {
    if (!isMobile) {
      setShowOverlay(true);
    }
  };

  const handleMouseLeave = () => {
    if (!isMobile) {
      setShowOverlay(false);
    }
  };

  const handleEvaluate = (e: React.MouseEvent) => {
    e.stopPropagation();
    onEvaluate(imageType.image_type_id);
  };

  return (
    <div 
      className="judge-image-card"
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {/* Imagen de fondo */}
      <div className="judge-card-image">
        {imageType.example_image_url ? (
          <img 
            src={imageType.example_image_url} 
            alt={imageType.image_type_name}
          />
        ) : (
          <div className="judge-card-placeholder">
            📸
          </div>
        )}
      </div>

      {/* Overlay con información */}
      {showOverlay && (
        <div className="judge-card-overlay">
          <div className="overlay-content">
            <h3>{imageType.image_type_name}</h3>
            
            {/* Barra de progreso mini */}
            <div className="progress-mini">
              <div 
                className="progress-mini-bar"
                style={{ width: `${progress}%` }}
              />
            </div>
            
            <p className="progress-text">
              ✅ {imageType.evaluated_submissions}/{imageType.total_submissions} evaluadas
            </p>

            {imageType.pending_submissions > 0 ? (
              <Button
                variant="primary"
                size="sm"
                onClick={handleEvaluate}
              >
                VER Y EVALUAR →
              </Button>
            ) : (
              <div className="completed-badge">
                ✅ Completado
              </div>
            )}
          </div>
        </div>
      )}

      {/* Badge de progreso (siempre visible) */}
      <div className="judge-card-badge">
        {imageType.pending_submissions > 0 ? (
          <span className="badge-pending">{imageType.pending_submissions}</span>
        ) : (
          <span className="badge-complete">✓</span>
        )}
      </div>
    </div>
  );
};

export default JudgeImageTypeCard;